/* eslint-disable @typescript-eslint/no-explicit-any */
import { ListItem, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  item: {
    borderRadius: theme.shape.borderRadius,
  },
}));

export const ListItemLink = ({
  href,
  ...props
}: { href: string } & any): JSX.Element => {
  const classes = useStyles();
  const { pathname } = useLocation();
  return (
    <ListItem
      button
      component={NavLink}
      to={href}
      {...props}
      className={clsx(props.className, classes.item)}
      selected={href.replace(/\/$/, '') === pathname.replace(/\/$/, '')} // https://github.com/ReactTraining/react-router/issues/4841
    />
  );
};
